import Vue from 'vue'
import define from '../systemAdminDefineModules/systemAdminDefineMutation.js'
// notifications-action
const URL = process.env.API_MASTER_URL
const header = define.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate(store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  updateSelectedTenantList(store, payload) {
    store.commit('updateSelectedTenantList', payload)
  },
  clearUpdateData(store) {
    store.commit('clearUpdateData')
  },
  clearAddData(store) {
    store.commit('clearAddData')
  },
  clearSelectedTenantList(store) {
    store.commit('clearSelectedTenantList')
  },
  async setNotifications(store, payload) {
    store.state.notifications = []
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        pageNo: payload.pageNo,
        count: 20
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/master/notification/list',
      data,
      config
    )

    // 成功後の処理
    store.commit('setNotifications', response)
  },

  async setSelectedTenantNotifications(store, payload) {
    store.state.notifications = []
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        tenantId: payload.tenantId,
        pageNo: payload.pageNo,
        count: 20
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/master/notification/list',
      data,
      config
    )

    // 成功後の処理
    store.commit('setNotifications', response)
  },

  async setNotificationDetail(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        notificationId: payload.notificationId
      }
    }
    var response = await Vue.http.post(
      URL + '/v2/master/notification/detail',
      data,
      config
    )

    // 成功後の処理
    store.commit('setNotificationsDetail', response)
  },

  async addNotification(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        title: payload.title,
        message: payload.message,
        startDateTime: payload.startDateTime,
        endDateTime: payload.endDateTime,
        allFlag: payload.allFlag,
        companyIdList: payload.companyIdList
      }
    }
    await Vue.http.post(URL + '/v2/master/notification/regist', data, config)
  },

  async updateNotification(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        notificationId: payload.notificationId,
        title: payload.title,
        message: payload.message,
        startDateTime: payload.startDateTime,
        endDateTime: payload.endDateTime,
        allFlag: payload.allFlag,
        companyIdList: payload.companyIdList
      }
    }
    await Vue.http.post(URL + '/v2/master/notification/update', data, config)
  },

  async deleteNotification(store, payload) {
    const config = {
      headers: {
        Authorization: define.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {
        notificationId: payload.notificationId
      }
    }
    await Vue.http.post(URL + '/v2/master/notification/delete', data, config)
  }
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/notificationsModules/actions.js